import { Injectable } from "@angular/core";
import { ApiService } from 'app/providers/api.service';
import { resolve } from "dns";
import { reject } from "lodash";
import { BehaviorSubject } from 'rxjs';


@Injectable({
  providedIn: "root",
})

export class loanDisbursementService {
  prclorgntrlst: any;
  constructor(private apiSrvc: ApiService) { }


  private paymentDetailsSource = new BehaviorSubject<any>(null);
  paymentDetails$ = this.paymentDetailsSource.asObservable();

  updatePaymentDetails(details: any) {
    console.log(details);
    this.paymentDetailsSource.next(details);
  }


  getLoanCreationDcumnts = (post_data, callback) => {
    const rte = '/loan-master/get/loan/dcmnts';
    this.apiSrvc.post(post_data, rte).subscribe((res) => {
      if (res['status'] == 200) {
        callback(false, res)
      } else {
        callback(true, res['message'])
      }
    }, (err) => {
      callback(true, 'Network failed.')
    })
  }
  getsectors = (callback) => {
    const rte = '/core/api/master/loan-sectors/list';
    this.apiSrvc.get(rte).subscribe((res) => {
      if (res['status'] == 200) {
        callback(false, res)
      } else {
        callback(true, res['message'])
      }
    }, (err) => {
      callback(true, 'Network failed.')
    })

  }
  getSctorWiseschemes = (id, callback) => {

    const rte = `/core/api/master/loan-sectors/${id}/loan-schemes`;
    this.apiSrvc.get(rte).subscribe((res) => {
      if (res['status'] == 200) {
        callback(false, res)
      } else {
        callback(true, res['message'])
      }
    }, (err) => {
      callback(true, 'Network failed.')
    })

  }




  getbnfcrydtls(id) {
    const rte = 'loan-master/get/bnfcrydtls/' + id
    return new Promise((resolve, reject) => {
      this.apiSrvc.get(rte).subscribe((res) => {
        resolve(res)
      })
    })
  }
  getLoanSuretyTypes(callback) {
    const rte = `/core/api/master/loan-surety-types/list`;
    this.apiSrvc.get(rte).subscribe((res) => {
      if (res['status'] == 200) {
        callback(false, res)
      } else {
        callback(true, res['message'])
      }
    }, (err) => {
      callback(true, 'Network failed.')
    })

  }
  getTrenches(callback) {
    const rte = `/core/api/master/loan-trenches/list`;
    this.apiSrvc.get(rte).subscribe((res) => {
      if (res['status'] == 200) {
        callback(false, res)
      } else {
        callback(true, res['message'])
      }
    }, (err) => {
      callback(true, 'Network failed.')
    })

  }
  gettenchePlans(ln_trnch_id, callback) {
    const rte = `/loan-master/get/loan/palans/${ln_trnch_id}`;
    this.apiSrvc.get(rte).subscribe((res) => {
      if (res['status'] == 200) {
        callback(false, res)
      } else {
        callback(true, res['message'])
      }
    }, (err) => {
      callback(true, 'Network failed.')
    })

  }
  getLoantype(callback) {
    const rte = `/loan-master/get/loan/types`;
    this.apiSrvc.get(rte).subscribe((res) => {
      if (res['status'] == 200) {
        callback(false, res)
      } else {
        callback(true, res['message'])
      }
    }, (err) => {
      callback(true, 'Network failed.')
    })

  }
  getpymnt(callback) {
    const rte = `/core/api/master/pymnt_types/list`;
    this.apiSrvc.get(rte).subscribe((res) => {
      if (res['status'] == 200) {
        callback(false, res)
      } else {
        callback(true, res['message'])
      }
    }, (err) => {
      callback(true, 'Network failed.')
    })

  }
  getben_dtls(ln_id, callback) {
    const rte = `loan-master/payment/history/details/${ln_id}`;
    this.apiSrvc.get(rte).subscribe((res) => {
      if (res['status'] == 200) {
        callback(false, res)
      } else {
        callback(true, res['message'])
      }
    }, (err) => {
      callback(true, 'Network failed.')
    })

  }
  getsuretyAssetTypes(callback) {
    const rte = `/core/api/master/asset-surety-types/list`;
    this.apiSrvc.get(rte).subscribe((res) => {
      if (res['status'] == 200) {
        callback(false, res)
      } else {
        callback(true, res['message'])
      }
    }, (err) => {
      callback(true, 'Network failed.')
    })

  }
  //   getLoanCreationDcumnts = (post_data, callback) => {
  //     const rte = '/loan-master/get/loan/dcmnts';
  //     this.apiSrvc.post(post_data, rte).subscribe((res) => {
  //       if (res['status'] == 200) {
  //         callback(false, res)
  //       } else {
  //         callback(true, res['message'])
  //       }
  //     }, (err) => {
  //         callback(true, 'Network failed.')
  //       })
  //     }

  addBenficiary = (post_data, callback) => {
    const rte = 'loan-master/create/new/loan';
    this.apiSrvc.post(post_data, rte).subscribe((res) => {
      if (res['status'] == 200) {
        callback(false, res)
      } else {
        callback(true, res['message'])
      }
    }, (err) => {
      callback(true, 'Network failed.')
    })
  }
  updateBenficiary = (post_data, callback) => {
    const rte = 'loan-master/update/new/loan';
    this.apiSrvc.post(post_data, rte).subscribe((res) => {
      if (res['status'] == 200) {
        callback(false, res)
      } else {
        callback(true, res['message'])
      }
    }, (err) => {
      callback(true, 'Network failed.')
    })
  }

  getsuretydocs(id, hndlr_tx) {
    // const rte = 'loan-master/get/bnfcrydcmnts/' + id
    const rte = 'documents/document/types/' + id + '/' + hndlr_tx
    return new Promise((resolve, reject) => {
      this.apiSrvc.get(rte).subscribe((res) => {
        console.log(res)
        resolve(res)
      })
    })
  }

  getstsLst() {
    const rte = 'loan-master/get/loan/status'
    return new Promise((resolve, reject) => {
      this.apiSrvc.get(rte).subscribe((res) => {
        resolve(res)
      })
    })
  }


  sbmtdta(postdata) {
    const rte = 'loan-master/submit/loan/surty'
    return new Promise((resolve, reject) => {
      this.apiSrvc.put(postdata, rte).subscribe((res) => {
        resolve(res)
      })
    })
  }

  sbmtchoicedta(postdata) {
    const rte = 'loan-master/submit/choiceltr'
    return new Promise((resolve, reject) => {
      this.apiSrvc.put(postdata, rte).subscribe((res) => {
        resolve(res)
      })
    })
  }
  getPartnerContributions(data) {
    const rte = 'loan-master/get/loan/partner/amounts'
    return new Promise((resolve, reject) => {
      this.apiSrvc.post(data, rte).subscribe((res) => {
        resolve(res)
      })
    })

  }
  getBenficiaryDetails() {
    const rte = 'loan-master/get/benficiary/details'
    return new Promise((resolve, reject) => {
      this.apiSrvc.get(rte).subscribe((res) => {
        resolve(res)
      })
    })

  }
  getcnbtramnt(ln_id) {
    const rte = 'loan-master/get/cntbtramnt_pd/${ln_id}'
    return new Promise((resolve, reject) => {
      this.apiSrvc.get(rte).subscribe((res) => {
        resolve(res)
      })
    })

  }
  sndwtsp(ln_id) {
    const rte = 'loan-master/send/benfcntrbtn/:ln_id'
    return new Promise((resolve, reject) => {
      this.apiSrvc.get(rte).subscribe((res) => {
        resolve(res)
      })
    })

  }
  // getcnbtramnt = ( callback) => {
  //   const rte = 'loan-master/get/cntbtramnt_pd';
  //   this.apiSrvc.get( rte).subscribe((res) => {
  //     if (res['status'] == 200) {
  //       callback(false, res)
  //     } else {
  //       callback(true, res['message'])
  //     }
  //   }, (err) => {
  //     callback(true, 'Network failed.')
  //   })
  // }
  getLoanDetails(ln_id) {
    const rte = `loan-master/get/loan/details/${ln_id}`
    return new Promise((resolve, reject) => {
      this.apiSrvc.get(rte).subscribe((res) => {
        resolve(res)
      })
    })
  }



  getdtls(ln_id) {
    const rte = `loan-master/get/pymntdtls/${ln_id}`;
    return new Promise((resolve, reject) => {
      this.apiSrvc.get(rte).subscribe(
        (res) => {
          resolve(res);
        },
        (err) => {
          reject(err);
        }
      );
    });
  }



  submtUpfrmAmntClntn(data, callback) {
    console.log(data, "sbmitttttttttttttttttttttt")
    const rte = `loan-master/submit/ben-loan-contribution`;
    this.apiSrvc.post(data, rte).subscribe((res) => {
      if (res['status'] == 200) {
        callback(false, res)
      } else {
        callback(true, res['message'])
      }
    }, (err) => {
      callback(true, 'Network failed.')
    })

  }
  getloaninfo(data) {
    const rte = `loan-master/get/loanifo/schme_sctr`
    return new Promise((resolve, reject) => {
      this.apiSrvc.post(data, rte).subscribe((res) => {
        resolve(res)
      })
    })

  }


  getallbnfcrydocs(postdata) {
    const rte = `loan-master/get/bnfcry/dcmntdtls`
    return new Promise((resolve, reject) => {
      this.apiSrvc.post(postdata, rte).subscribe((res) => {
        resolve(res)
      })
    })
  }

  getBenAllPrcsDocumnts(postdata) {
    const rte = `loan-master/get/bnfcry/document/ids`
    return new Promise((resolve, reject) => {
      this.apiSrvc.post(postdata, rte).subscribe((res) => {
        resolve(res)
      })
    })
  }


  updateCntrbtnAt(data, callback) {
    console.log(data, "Updating contribution amount");
    const rte = `loan-master/upfront-amount/updtcntrbtn_at`;

    this.apiSrvc.post(data, rte).subscribe((res) => {
      if (res['status'] == 200) {
        callback(false, res);
      } else {
        callback(true, res['message']);
      }
    }, (err) => {
      callback(true, 'Network failed.');
    });
  }

  getmasterfrms() {
    console.log("service calling")
    const rte = `admin/mstrfiles`
    return new Promise((resolve, reject) => {
      this.apiSrvc.get(rte).subscribe((res) => {
        resolve(res)
      })
    })
  }

  surtysts(ln_id) {
    const rte = `loan-master/get/srty/sts/${ln_id}`
    return new Promise((resolve, reject) => {
      this.apiSrvc.get(rte).subscribe((res) => {
        resolve(res)
      })
    })
  }
  getlnstsLst() {
    const rte = 'loan-master/get/loan/ststs'
    return new Promise((resolve, reject) => {
      this.apiSrvc.get(rte).subscribe((res) => {
        resolve(res)
      })
    })
  }
  sbmtdtalnsts(postdata) {
    const rte = 'loan-master/submit/loan/status'
    return new Promise((resolve, reject) => {
      this.apiSrvc.post(postdata, rte).subscribe((res) => {
        resolve(res)
      })
    })
  }



  getemidata(data) {
    const rte = `loan-master/get/emi/dtls`
    return new Promise((resolve, reject) => {
      this.apiSrvc.post(data, rte).subscribe((res) => {
        resolve(res)
      })
    })
  }
  getDrftPndngLns(data) {
    const rte = `loan-master/get/draft/pending/loans`
    return new Promise((resolve, reject) => {
      this.apiSrvc.post(data, rte).subscribe((res) => {
        resolve(res)
      })
    })
  }
  getProcedingPndngLns(data) {
    const rte = `loan-master/get/proceding/pending/loans/counts`
    return new Promise((resolve, reject) => {
      this.apiSrvc.post(data, rte).subscribe((res) => {
        resolve(res)
      })
    })
  }
  getScmeWseDrftPndngLns(data) {
    const rte = `loan-master/get/SctrWisedraft/pending/loans`
    return new Promise((resolve, reject) => {
      this.apiSrvc.post(data, rte).subscribe((res) => {
        resolve(res)
      })
    })
  }
  getScmeWseProcedingPndngLns(data) {
    const rte = `loan-master/SctrWisedraft/proceeding/pending/loans`
    return new Promise((resolve, reject) => {
      this.apiSrvc.post(data, rte).subscribe((res) => {
        resolve(res)
      })
    })
  }
  getBulkDDgenerateData(data) {
    const rte = `loan-master/bulkddgenerate/loan/amounts`
    return new Promise((resolve, reject) => {
      this.apiSrvc.post(data, rte).subscribe((res) => {
        resolve(res)
      })
    })
  }
  GeneratePrcdings(data) {
    const rte = `loan-master/generate/procedings`
    return new Promise((resolve, reject) => {
      this.apiSrvc.post(data, rte).subscribe((res) => {
        resolve(res)
      })
    })
  }

  getaptldtls(postdata) {
    const rte = 'loan-master/get/aprvl/dtls'
    return new Promise((resolve, reject) => {
      this.apiSrvc.post(postdata, rte).subscribe((res) => {
        resolve(res)
      })
    })
  }

  generatePdf(postdata) {
    console.log(postdata, "9999991111111")
    const rte = `loan-master/get/form/values`
    return new Promise((resolve, reject) => {
      this.apiSrvc.post(postdata, rte).subscribe((res) => {
        resolve(res)
      })
    })
  }
  generateNOCPdf(postdata) {
    console.log(postdata, "9999991111111")
    const rte = `loan-master/get/nocform/values`
    return new Promise((resolve, reject) => {
      this.apiSrvc.post(postdata, rte).subscribe((res) => {
        resolve(res)
      })
    })
  }

  getallbnfcrymaterdocs(postdata) {
    const rte = `loan-master/get/bnfcry/masterformsdtls`
    return new Promise((resolve, reject) => {
      this.apiSrvc.post(postdata, rte).subscribe((res) => {
        resolve(res)
      })
    })
  }
  getdocuploadhistory(postdata) {
    const rte = `loan-master/emi/demand/notice/generate`
    return new Promise((resolve, reject) => {
      this.apiSrvc.post(postdata, rte).subscribe((res) => {
        resolve(res)
      })
    })
  }

  getBenfLoanDetails(benf_id) {
    const rte = `loan-master/get/bnfcry/loan/details/${benf_id}`
    return new Promise((resolve, reject) => {
      this.apiSrvc.get(rte).subscribe((res) => {
        resolve(res)
      })
    })
  }

  getBenfDetails(benf_id) {
    const rte = `loan-master/get/bnfcrydtls/${benf_id}`
    return new Promise((resolve, reject) => {
      this.apiSrvc.get(rte).subscribe((res) => {
        resolve(res)
      })
    })
  }



  getContrubtionLnEmiDtls(ln_id) {
    const rte = `loan/get/loans/cntrbdtls/${ln_id}`
    return new Promise((resolve, reject) => {
      this.apiSrvc.get(rte).subscribe((res) => {
        resolve(res)
      })
    })
  }

  getprcdngAprveCnts(postdata) {
    const rte = `loan-master/preceeding/approve/counts`
    return new Promise((resolve, reject) => {
      this.apiSrvc.post(postdata, rte).subscribe((res) => {
        resolve(res)
      })
    })
  }
  pendingApprvlData(ln_fnd_trns_id) {
    const rte = `loan-master/get/proceding/approve/loans/${ln_fnd_trns_id}`
    return new Promise((resolve, reject) => {
      this.apiSrvc.get(rte).subscribe((res) => {
        resolve(res)
      })
    })
  }
  pendingDraftApprvlData(ln_fnd_trns_id) {
    const rte = `loan-master/get/draft/approve/loans/${ln_fnd_trns_id}`
    return new Promise((resolve, reject) => {
      this.apiSrvc.get(rte).subscribe((res) => {
        resolve(res)
      })
    })

  }
  ApproveProceedings(data) {
    const rte = `loan-master/approve/proceeding`
    return new Promise((resolve, reject) => {
      this.apiSrvc.post(data, rte).subscribe((res) => {
        resolve(res)
      })
    })
  }
  RejectProceedings(data) {
    const rte = `loan-master/reject/proceeding`
    return new Promise((resolve, reject) => {
      this.apiSrvc.post(data, rte).subscribe((res) => {
        resolve(res)
      })
    })

  }
  procedngGnrtCntHndlrs(data) {
    const rte = `loan-master/proceeding/generate/cntHndlrs`
    return new Promise((resolve, reject) => {
      this.apiSrvc.post(data, rte).subscribe((res) => {
        resolve(res)
      })
    })

  }
  DDGnrtCntHndlrs(data) {
    const rte = `loan-master/draft/generate/cntHndlrs`
    return new Promise((resolve, reject) => {
      this.apiSrvc.post(data, rte).subscribe((res) => {
        resolve(res)
      })
    })

  }
  GenerateDemanddraft(data) {
    const rte = `loan-master/generate/demand/draft`
    return new Promise((resolve, reject) => {
      this.apiSrvc.post(data, rte).subscribe((res) => {
        resolve(res)
      })
    })

  }
  getVndrCnfrmtnDta(data) {
    const rte = `loan-master/vendorCnfrmtn/data`
    return new Promise((resolve, reject) => {
      this.apiSrvc.post(data, rte).subscribe((res) => {
        resolve(res)
      })
    })


  }
  sendLinktoVendor(data) {
    const rte = `loan-master/sendLink/vendor`
    return new Promise((resolve, reject) => {
      this.apiSrvc.post(data, rte).subscribe((res) => {
        resolve(res)
      })
    })


  }
  sendbnkdtlsLinktoVendor(vndr_id) {
    const rte = `loan-master/send/vendor/bank/confirm/details/whtpsmsg/${vndr_id}`
    return new Promise((resolve, reject) => {
      this.apiSrvc.post(vndr_id, rte).subscribe((res) => {
        resolve(res)
      })
    })


  }


  benfemiPydRcpt(data) {
    const rte = `loan-master/beneficiary/emiPydRcpt`
    return new Promise((resolve, reject) => {
      this.apiSrvc.post(data, rte).subscribe((res) => {
        resolve(res)
      })
    })


  }


  initiate_pay_link(data, callback) {
    console.log(data, "sbmitttttttttttttttttttttt")
    const rte = `loan-master/submit/ben-loan-contribution/initiate_pay_link`;
    this.apiSrvc.post(data, rte).subscribe((res) => {
      if (res['status'] == 200) {
        callback(false, res)
      } else {
        callback(true, res['message'])
      }
    }, (err) => {
      callback(true, 'Network failed.')
    })

  }


  frwrdBenfPaystage(data, callback) {
    console.log(data, "frwrdBenfPaystage sbmitttttttttttttttttttttt")
    const rte = `loan-master/submit/ben-loan-contribution/frwrdBenfPaystage`;
    this.apiSrvc.post(data, rte).subscribe((res) => {
      if (res['status'] == 200) {
        callback(false, res)
      } else {
        callback(true, res['message'])
      }
    }, (err) => {
      callback(true, 'Network failed.')
    })

  }
  gettrnchs() {
    const rte = `loan-master/get/trnchs`
    return new Promise((resolve, reject) => {
      this.apiSrvc.get(rte).subscribe((res) => {
        resolve(res)
      })
    })
  }




  bnfrcypymntsndwtsup(data, callback) {
    console.log(data, "sbmitttttttttttttttttttttt")
    const rte = `loan-master/submit/ben-loan-contribution/initiate_pay_link/snd_to_vndr`;
    this.apiSrvc.post(data, rte).subscribe((res) => {
      if (res['status'] == 200) {
        callback(false, res)
      } else {
        callback(true, res['message'])
      }
    }, (err) => {
      callback(true, 'Network failed.')
    })
  }
}